module.exports = __webpack_public_path__ + "img/footer-logo.257a58bc.svg";